// Module
var code = "<h3>Your Xero Entities</h3> <div id=\"noConnection\" class=\"block is-hidden\">You do not have a valid connection with Xero.</div> <div id=\"tenantsGrid\" class=\"block\"></div> <div id=\"tokenInfo\" class=\"block box\"></div>";
// Exports
export default code;